query CardHolders($filter: CardHolderFilter, $orderBy: [CardHoldersOrderBy!]) {
  cardHolders(filter: $filter, orderBy: $orderBy) {
    nodes {
      id
      cardAccountId
      _isUpdatable
      _isDeletable
      _rowTimestamp
      cardFirstName
      cardLastName
      cardFullName
      cardNumber
      cardExpiry
      departments {
        name
      }
      documentPools {
        name
      }
      cardStatus
    }
    totalCount
  }
}
